export default __webpack_public_path__ + "static/media/basket.c7b1a6fb.svg";